import _extends from "@babel/runtime/helpers/extends";
import { useMenuItem } from "@react-aria/menu";
import React from "react";
import styled from "styled-components";
import { propStyling } from "../../shared/propStyling";
import { textStyles } from "../../shared/textStyles";
import { tombac } from "../../shared/tombac";
import { StyledListBox } from "../internal/StyledListBox";

/** Props for the MenuItem component. */

export function MenuItemRenderer(_ref) {
  let {
    item,
    treeState
  } = _ref;
  const {
    contentContainerProps,
    prepend,
    prependContainerProps,
    ...itemProps
  } = item.props || {};
  const itemRef = React.useRef(null);
  const {
    descriptionProps,
    labelProps,
    isDisabled,
    isFocused,
    isPressed,
    menuItemProps
  } = useMenuItem({
    key: item.key
  }, treeState, itemRef);
  const stateProps = {
    isDisabled,
    isFocused,
    isPressed
  };
  const rendered = typeof item.rendered === "function" ? item.rendered({
    descriptionProps,
    labelProps
  }) : item.rendered;
  return /*#__PURE__*/React.createElement(StyledListBox.Item, _extends({}, itemProps, contentContainerProps, menuItemProps, stateProps, {
    hasPrepend: !!prepend,
    ref: itemRef
  }), prepend ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Prepended, prependContainerProps, prepend), /*#__PURE__*/React.createElement(Content, contentContainerProps, rendered)) : rendered);
}
const Content = styled.div.withConfig({
  displayName: "MenuItem__Content"
})(["all:revert;", " ", ""], propStyling, textStyles);
const Prepended = styled.div.withConfig({
  displayName: "MenuItem__Prepended"
})(["all:revert;margin-right:", ";min-width:", ";text-align:center;", " ", ""], tombac.space(1), tombac.space(3), propStyling, textStyles);
//# sourceMappingURL=MenuItem.js.map